import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { AddNewMemberDialogComponent } from '../add-new-member-dialog/add-new-member-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { IChatGroupMembers, IOpenGroupInfoPayload, IRemoveChatGroupMember, IUpdateChatGroupModel, IUpdateMemberStatus } from 'src/app/model/internalGroupChat.model';
import { InternalGroupChatService } from '../../internal-group-chat.service';
import { ILoggedInUserViewModel } from 'src/app/model/common.model';
import { ConfirmationMsg } from 'src/app/@shared/constants/confirmation-msg.constant';
import { RoleName } from 'src/app/@shared/constants/Constant';
import { MessagePanelComponent } from '../../message-panel/message-panel.component';
import { IAssignedRole } from 'src/app/service/memeber.model';

@Component({
  selector: 'app-group-info-dialog',
  templateUrl: './group-info-dialog.component.html',
  styleUrls: ['./group-info-dialog.component.css']
})
export class GroupInfoDialogComponent implements OnInit {
  public user: ILoggedInUserViewModel;
  public loader: boolean
  public isUpdate: boolean;
  public groupName: string = '';
  public groupNameLength: number = 50;
  public groupNameLengthRemainingToShowOnUI: number = this.groupNameLength - this.groupName.length;
  public sortBy: string = "memberFirstName";
  public sortOrder: boolean = false;
  public isLoggedInMemberAGroupAdmin: boolean;
  public isInternal: boolean;

  constructor(
    private _toast: ToastrService,
    private _dialog: MatDialog,
    private _internalGroupChatService: InternalGroupChatService,
    @Inject(MAT_DIALOG_DATA) public data: IOpenGroupInfoPayload,
    public dialogRef: MatDialogRef<MessagePanelComponent>
  ) { }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('user'));
    if (this.data !== null) {
      this.groupName = this.data?.groupDetail.groupName;
      this.sliceExtraText(this.groupNameLength);
    }
    this.isInternal = this.user.role === RoleName.ExecutiveAdmin || this.user.role === RoleName.Coordinator || this.user.role === RoleName.Management;
    this.isLoggedInMemberAGroupAdmin = this.data.memberList.some(member => member.memberId === this.user.memberId && member.isGroupAdmin === true);
  }

  sliceExtraText(limitToShowText: number) {
    this.groupName = this.groupName ? this.groupName.slice(0, limitToShowText) : null;
    this.lengthToShowOnUI();
  }

  lengthToShowOnUI() {
    this.groupName = this.groupName ? this.groupName : '';
    this.groupNameLengthRemainingToShowOnUI = this.groupNameLength - this.groupName.length;
  }

  openAddNewMemberDialog() {
    if (this.data && this.data.memberList.length === 20) {
      this._toast.warning('Cannot add more than 20 members in a group!', 'Warning',
        {
          timeOut: 6000,
          positionClass: "toast-top-center",
        });
    }
    else {
      const dialogRef = this._dialog.open(AddNewMemberDialogComponent, {
        maxWidth: '80rem',
        width: '100%',
        minWidth: '21rem',
        data: this.data,
        height: 'fit-content',
      });
      dialogRef.afterClosed().subscribe((response: IChatGroupMembers[]) => {
        if (response && response.length > 0) {
          this.data.memberList = response;
        }
      })
    }
  }
  updateAdminStatus(member: IChatGroupMembers) {
    let updateMemberStatusPayload: IUpdateMemberStatus = {
      chatGroupId: this.data?.groupDetail.chatGroupId,
      memberId: member.memberId,
      modifiedBy: this.user.memberId,
      isGroupAdmin: !member.isGroupAdmin
    }
    if (
      (updateMemberStatusPayload.isGroupAdmin === false && this.data.memberList?.filter(member => member.isGroupAdmin === true).length > 1) ||
      (updateMemberStatusPayload.isGroupAdmin === true)
    ) {
      this.loader = true;
      this._internalGroupChatService.updateGroupMemberStatus(updateMemberStatusPayload).subscribe(
        (response) => {
          this.loader = false;
          // if (updateMemberStatusPayload.memberId === updateMemberStatusPayload.modifiedBy && updateMemberStatusPayload.isGroupAdmin === false) {
          //   this.isLoggedInMemberAGroupAdmin = false;
          // }
          this.data.memberList.filter(member => updateMemberStatusPayload.memberId === member.memberId)[0].isGroupAdmin = updateMemberStatusPayload.isGroupAdmin;
          this._internalGroupChatService.updateGroupInfoSubject$.next({
            serviceRequestDetail: this.data.serviceRequestDetail,
            groupDetail: this.data?.groupDetail,
            memberList: this.data.memberList
          });
        },
        (error) => {
          this.loader = false;
          this._toast.warning('Unable to update the member status!', 'Warning',
            {
              timeOut: 6000,
              positionClass: "toast-top-center",
            });
        }
      )
    }
    else {
      this._toast.warning('Group requires at least one Group Admin', 'Warning',
        {
          timeOut: 6000,
          positionClass: "toast-top-center",
        });
    }
  }
  removeMember(memberToBeRemoved: IChatGroupMembers) {
    if (this.data.memberList.length > 1) {
      let confirmation: boolean = confirm(ConfirmationMsg.removeMember(memberToBeRemoved.memberFirstName));
      if (confirmation) {
        let removeMemberPayload: IRemoveChatGroupMember = {
          chatGroupId: this.data?.groupDetail.chatGroupId,
          memberId: memberToBeRemoved.memberId,
          updatedBy: this.user.memberId,
          isGroupAdmin: memberToBeRemoved.isGroupAdmin
        }
        this.loader = true;
        this._internalGroupChatService.removeGroupMember(removeMemberPayload).subscribe(
          (response) => {
            this.loader = false;
            if (response.data === true) {
              this.data.memberList = this.data.memberList?.filter(member => member.memberId !== memberToBeRemoved.memberId);
              this._internalGroupChatService.updateGroupInfoSubject$.next({
                serviceRequestDetail: this.data.serviceRequestDetail,
                groupDetail: this.data?.groupDetail,
                memberList: this.data.memberList?.filter(member => member.memberId !== removeMemberPayload.memberId)
              });
            }
            else {
              this._toast.warning('Unable to remove the member from the group. Please refresh the page or try again later!', 'Warning',
                {
                  timeOut: 6000,
                  positionClass: "toast-top-center",
                });
            }
          },
          (error) => {
            this.loader = false;
            console.log(error);
            this._toast.warning('Unable to remove the member from the group. Please try again later!', 'Warning',
              {
                timeOut: 6000,
                positionClass: "toast-top-center",
              });
          }
        );
      }
    }
    else {
      this._toast.warning('Minimum 1 Members is required in the group!', 'Warning',
        {
          timeOut: 6000,
          positionClass: "toast-top-center",
        });
    }
  }

  resetGroupName() {
    this.isUpdate = false;
    this.groupName = this.data?.groupDetail.groupName;
    this.sliceExtraText(this.groupNameLength);
  }

  updateGroupName() {
    let updateGroupInfoPayload: IUpdateChatGroupModel = {
      chatGroupId: this.data?.groupDetail.chatGroupId,
      groupName: this.groupName,
      groupDescription: null,
      updatedBy: this.user.memberId
    }
    if (this.groupName && this.groupName.trim().length > 0) {
      this.loader = true;
      this._internalGroupChatService.updateGroupChat(updateGroupInfoPayload).subscribe(
        (response) => {
          this.loader = false;
          this.isUpdate = false;
          this.data.groupDetail.groupName = this.groupName;
          this._internalGroupChatService.updateGroupInfoSubject$.next({
            serviceRequestDetail: this.data.serviceRequestDetail,
            groupDetail: this.data?.groupDetail,
            memberList: this.data.memberList
          });
        },
        (error) => {
          this.loader = false;
          this._toast.warning('Unable to update the Group Information!', 'Warning',
            {
              timeOut: 6000,
              positionClass: "toast-top-center",
            });
        }
      )
    }
    else if (this.groupName === null || this.groupName === '' || (this.groupName && this.groupName.trim().length === 0)) {
      this._toast.warning('Please enter Group Name!', 'Warning',
        {
          timeOut: 6000,
          positionClass: "toast-top-center",
        });
    }
  }

  isLoggedMemberAGroupAdmin() {
    // TODO: This is to check that the logged in user is a group admin of that group or not
    return this.data.memberList.some(member => member.memberId === this.user.memberId && member.isGroupAdmin);
  }

  getMemberRoleList(roleDetailList: IAssignedRole[]): string {
    return roleDetailList?.map((role) => role.roleName).sort().join(', ');
  }

}
